import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setReminderThread, unsetReminderThread } from "../../../actions/ThreadAction";
import { SET_PATIENT_INFO_REDUCED, SET_HAS_CRITICAL } from "../../../actions/types";
import Notify from '../../Common/Notify';
import "./Reminder.css";
import moment from "moment";

const $ = window.$;

function ReminderModal({
  circleId,
  currentReminder,
  modalClose = () => {}
}) {
  const dispatch = useDispatch();

  const { 
    patientInfoReduced,
  } = useSelector(mySelector, shallowEqual);

  const [reminder, setReminder] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [isRemoving, setRemoving] = useState(false);

  useEffect(() => {
    //
  }, []);

  const handleChange = (reminder) => {
    setReminder(reminder.target.value);
  }

  const handleSetReminder = () => {
    setLoading(true);
    dispatch(setReminderThread(circleId, reminder))
      .then(() => {
        let patientInfo = patientInfoReduced;
        patientInfo.isCritical = true;

        setLoading(false);
        Notify.info('Successfully set reminder.');

        dispatch({
          type: SET_PATIENT_INFO_REDUCED,
          patientInfoReduced: patientInfo,
        });

        dispatch({
          type: SET_HAS_CRITICAL,
          hasCritical: true
        });

        modalClose();
      });
  }

  const handleUnsetReminder = () => {
    setLoading(true);
    setRemoving(true);
    dispatch(unsetReminderThread(circleId))
      .then(() => {
        let patientInfo = patientInfoReduced;
        patientInfo.isCritical = false;
        setLoading(false);
        setRemoving(false);
        Notify.info('Reminder remove.');
        
        dispatch({
          type: SET_PATIENT_INFO_REDUCED,
          patientInfoReduced: patientInfo,
        });

        modalClose();
      });
  }

  return (
    <div className="reminder-modal-container">
      <div className="reminder-container">
        <div className="save-changes-flex" style={{ marginLeft: 5 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
          <i className="fas fa-exclamation-circle hc-primary-text fa-1x"></i>
            <h6>{currentReminder === true ? 'Update' : 'Set'} Reminder</h6>
            <i className="fas fa-times" style={{float:'right'}} role='button' onClick={() => modalClose()} />
          </div>
        </div>
          <div className="radio selection-table-filter" onChange={(e) => handleChange(e)}>
            <span>
              <input 
                className="active"
                id="hourReminder"
                type="radio" 
                value="1h" 
                name="reminder"
                /> <label htmlFor="hourReminder"> 1 Hour</label> 
            </span>
            <>
              <label htmlFor="hourReminder"> {"( "}{moment().format("LT")} {")"}</label> 
            </>
            <span>
              <input 
                id="dayReminder"
                type="radio" 
                value="1d" 
                name="reminder" 
                /> <label htmlFor="dayReminder"> 1 Day</label>
              </span>
            <>
              <label htmlFor="dayReminder"> {"( "}{moment().add(1, 'days').calendar()}{" )"}</label> 
            </>
            <span>
            <input 
              id="weekReminder"
              type="radio" 
              value="1w" 
              name="reminder" 
              /> <label htmlFor="weekReminder"> 1 Week</label> 
            </span>
            <>
              <label htmlFor="weekReminder"> {"( "}{moment().add(7, 'days').calendar()}{" )"}</label> 
            </>
          </div>
          <div style={{ marginTop: 20 }}>
            <button
              alignItems="left"
              type="button"
              style={{ marginRight: "10px" }}
              className="btn btn-hubchart btn-hubchart-danger"
              onClick={() => handleUnsetReminder()}
              disabled={isLoading || isRemoving}>
              {`${isRemoving ? 'Removing...' : 'Remove '}`}
            </button>
            <button
              type="button"
              style={{ float:'right' }}
              className="btn btn-hubchart btn-hubchart-primary"
              onClick={() => handleSetReminder()}
              disabled={isLoading || reminder === ''}>
              {`${isLoading && !isRemoving ? 
                  currentReminder === true ? 'Updating...' : 'Setting...' :
                  currentReminder === true ? 'Update Reminder' : 'Set Reminder' }`}
            </button>
          </div>
      </div>
    </div>
  );
}

const mySelector = (state) => ({
  patientInfoReduced: state.patient.patientInfoReduced,
});

export default ReminderModal;
